var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jobsheet",class:{ 'jobsheet--loading': _vm.loading }},[_c('Loader',{staticClass:"jobsheet__loader"}),_vm._l((_vm.orderIds),function(orderId){return _c('job-order',{key:orderId,attrs:{"orderId":orderId,"componentIds":_vm.componentIds},on:{"loaded":_vm.onLoad}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }